import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  text-align: center;
  height: 100%;
  justify-content: center;
  margin-top: 6.4rem;
  
  & > span {
    font-size: 1.6rem;
    font-style: italic;

    @media (min-width: 45em) {
      font-size: 2rem;
    }
  }


`;
